var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketplaceFiltersDummyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 26 28.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16839",
    "data-name": "Group 16839",
    transform: "translate(-135.998 -308.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16837",
    "data-name": "Group 16837",
    transform: "translate(0.406 2.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M190.932,80.364c-.133-.191-.446-.015-.316.185a1.56,1.56,0,0,1-.528,1.958c-.531.484-1.192.815-1.677,1.351a2.7,2.7,0,0,0-.131,3.451c.144.183.406-.05.309-.238a2.6,2.6,0,0,1-.2-1.882,3.321,3.321,0,0,1,1.235-1.632,4.835,4.835,0,0,0,1.359-1.441A1.714,1.714,0,0,0,190.932,80.364Z",
    transform: "translate(-42.298 229.679)",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M252.544,27.339c-.244-.436-.617-1.256-.056-1.626a.248.248,0,0,0-.25-.428,1.306,1.306,0,0,0-.677,1.265,5.641,5.641,0,0,0,.724,1.841,2.507,2.507,0,0,1-1.359,3.227c-.207.086-.133.418.1.348a2.945,2.945,0,0,0,2.1-2.695A3.57,3.57,0,0,0,252.544,27.339Z",
    transform: "translate(-102.27 281.988)",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M286.3,81.836c-.076-.485-.324-1.048-.117-1.531.133-.309-.277-.574-.464-.271-.5.811-.03,1.68-.1,2.547a2.439,2.439,0,0,1-1.247,1.891.151.151,0,0,0,.116.275,2.639,2.639,0,0,0,1.706-1.619A2.532,2.532,0,0,0,286.3,81.836Z",
    transform: "translate(-134.107 230.042)",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6457",
    "data-name": "Path 6457",
    d: "M181.33,1.739A2.336,2.336,0,0,0,179.906.032a1.251,1.251,0,0,0-1.48,1.1,1.349,1.349,0,0,0,.219,1.065.709.709,0,0,0,.95.166.256.256,0,1,0-.311-.4c-.178.164-.346-.109-.37-.262a1.048,1.048,0,0,1,.039-.462c.078-.256.262-.532.559-.537.607-.011.971.9,1.117,1.365a4.037,4.037,0,0,1-.551,3.634c-.1.136.119.3.233.18A4.3,4.3,0,0,0,181.33,1.739Z",
    transform: "translate(-33.439 306)",
    fill: "#a8a8aa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "food-tray",
    transform: "translate(133.998 305.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6451",
    "data-name": "Path 6451",
    d: "M25.4,53.721H4.6a2.6,2.6,0,0,1-2.6-2.6.371.371,0,0,1,.371-.371H27.629a.371.371,0,0,1,.371.371,2.6,2.6,0,0,1-2.6,2.6ZM2.78,51.493A1.86,1.86,0,0,0,4.6,52.979H25.4a1.86,1.86,0,0,0,1.82-1.486Z",
    transform: "translate(0 -22.314)",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M28.94,32.636H7.471a.371.371,0,0,1-.371-.371v-.409a11.106,11.106,0,1,1,22.211,0v.409A.371.371,0,0,1,28.94,32.636Zm-21.1-.743H28.569v-.037a10.363,10.363,0,1,0-20.726,0Z",
    transform: "translate(-3.206 -3.457)",
    fill: "#a8a8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M34.853,18.118a.379.379,0,0,1-.095-.012.371.371,0,0,1-.265-.454l.344-1.311a.277.277,0,0,0-.269-.348H32.536a.277.277,0,0,0-.269.348l.344,1.311a.372.372,0,0,1-.719.189l-.344-1.312a1.021,1.021,0,0,1,.988-1.279h2.032a1.021,1.021,0,0,1,.988,1.279l-.344,1.312A.371.371,0,0,1,34.853,18.118Z",
    transform: "translate(-18.553 0)",
    fill: "#a8a8aa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceFiltersDummyLogo);
export default __webpack_public_path__ + "static/media/marketplaceFiltersDummyLogo.aa28bb9285f04cc57a5ca5bc1001b256.svg";
export { ForwardRef as ReactComponent };